import AUTH_TOKEN from './authToken'

export default {
  Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`
}
